import { WritableSignal } from '@angular/core';

export const updateSignalState = <T, K extends keyof T>(
  signal: WritableSignal<T>,
  property: keyof T,
  value: T[K],
) => {
  signal.update((state) => ({
    ...state,
    [property]: value,
  }));
};
